<script>
import { mapState, mapActions } from "vuex";
import { SweetModal } from "sweet-modal-vue";
import config from "@/data/config";
import APIService from "@/services/api.service";
import axios from "axios";

export default {
	name: "umatPerLingkungan",
	components: { SweetModal },
	data() {
		return {
			info: {},
			loading: false,
			frameLoading: false,
			baseURL: config.baseURL,
			windowHeight: window.innerHeight - 250,
			fileURL: "",
		};
	},
	created() {
		this.findAll();
		this.getLingkunganStasi();
	},
	mounted() {
		console.log(this.lingkunganStasi);
	},
	computed: {
		...mapState({
			myData: (state) => state.laporan.data,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
	},
	watch: {
		loading: function (val) {
			if (val) {
				this.$swal({ text: "Loading", allowOutsideClick: false });
				this.$swal.showLoading();
			} else {
				this.$swal.close();
			}
		},
	},
	methods: {
		async findAll() {
			await this.$store.dispatch("laporan/getJumlahUmat");
		},
		...mapActions({
			insert: "pengguna/insert",
			update: "pengguna/update",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		refreshData() {
			this.getLingkunganStasi();
		},
		resetPDF() {
			this.loading = true;
			this.frameLoading = true;
			this.fileURL = this.baseURL + "assets/_blank.pdf";
		},
		onSuccess(response) {
         const timestamp = this.$moment().toDate().getTime()
			this.loading = false;
			this.fileURL = this.baseURL + "pdf/" + response.data.filename + ".pdf?v=" +  timestamp;
			this.$refs.modalfile.open();
		},
		showPDFUmat(lingkunganStasi) {
			this.resetPDF();

			const data = {
				lingkungan_stasi: lingkunganStasi,
			};

			axios
				.post(APIService.getPDFUmat(), data, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.onSuccess(response);
					},
					() => {
						this.loading = false;
					}
				);
		},
		downloadKK(lingkunganStasi) {
			this.loading = true;

			const data = {
				lingkungan_stasi: lingkunganStasi,
			};

			axios
				.post(APIService.getKKZIP(), data, {
					headers: APIService.getHeader(),
               responseType: "blob",
				})
				.then(
					(response) => {
						const url = URL.createObjectURL(
							new Blob([response.data], {
								type: "application/zip",
							})
						);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", lingkunganStasi + ".zip");
						document.body.appendChild(link);
						link.click();
						this.loading = false;
					},
					() => {
						this.loading = false;
					}
				);
		},
		load() {
			this.frameLoading = false;
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Laporan Cetak" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh"
									>
										<div
											v-show="isLoading"
											class="
												spinner-border spinner-border-sm
												text-light
											"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<!-- --------------------------- /FILTER --------------------------- -->

				<div class="card-body">
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<div class="table-responsive invoice-table">
							<table class="table table-bordered table-striped">
								<thead class="thead-light">
									<tr>
										<th class="text-center">NO.</th>
										<th class="text-center">NAMA</th>
										<th class="text-center">Daftar Anggota Lingkungan (PDF)</th>
										<th class="text-center">Download Kartu KK (Zip)</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in lingkunganStasi"
										:key="index"
									>
										<td class="text-center">{{ index + 1 }}</td>
										<td>{{ item }}</td>
										<td class="text-center">
											<b-btn-group>
												<b-button
													size="sm"
													variant="outline-dark"
													v-b-modal.modal-info
													@click="showPDFUmat(item)"
													v-b-tooltip.hover
													title="PDF"
												>
													<i class="fa fa-file-pdf-o"></i>
												</b-button>
											</b-btn-group>
										</td>
										<td class="text-center">
											<b-btn-group>
												<b-button
													size="sm"
													variant="outline-dark"
													v-b-modal.modal-info
													@click="downloadKK(item)"
													v-b-tooltip.hover
													title="PDF"
												>
													<i class="fa fa-file-zip-o"></i>
												</b-button>
											</b-btn-group>
										</td>
										<!-- <td class="text-center"></td> -->
									</tr>
								</tbody>
							</table>
						</div>
					</template>
				</div>
			</div>
		</div>

		<sweet-modal
			modal-theme="light"
			overlay-theme="dark"
			width="80%"
			ref="modalfile"
		>
			<div class="loader-box" v-show="frameLoading">
				<div class="loader-2"></div>
			</div>
			<iframe
				v-show="!frameLoading"
				width="100%"
				:height="windowHeight"
				:src="fileURL"
				frameborder="0"
				allowfullscreen
				@load="load()"
			></iframe>
		</sweet-modal>
	</div>
</template>

<style scoped>
.table tfoot {
	background-color: #212529;
}
.table tfoot td {
	color: #fff;
}

.table {
	font-size: 12px !important;
}

.table th,
.table td {
	padding: 0.5rem;
}
</style>